import { render } from "./PredictorDoughnutChart.vue?vue&type=template&id=f3b62034&scoped=true"
import script from "./PredictorDoughnutChart.vue?vue&type=script&lang=js"
export * from "./PredictorDoughnutChart.vue?vue&type=script&lang=js"

import "./PredictorDoughnutChart.vue?vue&type=style&index=0&id=f3b62034&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b62034"]])

export default __exports__